import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners';

class ShipmentsTable extends Component {
    state = {
        activeTab: 'all',
        searchTerm: '',
        pageIndex: 0,
        allSelected: false,
        selectedShipments: []
    }; 

    render() {

        let shipments = this.props.shipmentsList || [];

        return (
            <div className="card mb-4" style={{ height: 'auto' }}>
                <table className="table table-striped table-hover minayla-table">
                    <thead>
                        <tr>
                            <th>Shipment Id</th>
                            <th>Order #</th>
                            <th>Booking #</th>
                            <th>Container #</th>
                            <th>Size/Type</th>
                            <th>Status</th>
                            <th>ETA Date</th>
                            <th>Delivery Type</th>
                            <th>Terminal</th>
                            <th>Last Free Day</th>
                            <th>Port Status</th>
                            <th>Ref/BL#</th>
                            <th>Return Last Free Day</th>
                            <th>Consignee</th>
                            <th>Traverse Type</th>
                            <th></th>
                        </tr>
                        <tr id="gradient-row">
                            <td colSpan="16">
                                <div id="gradient-bar" className="bg-primary bg-gradient" />
                            </td>
                        </tr>
                    </thead>
                    {!this.props.isLoading && (<tbody>
                        {
                            !shipments.length ? <tr><td colSpan="16" className="text-center">NO SHIPMENT FOUND</td></tr>
                                :
                                shipments.map(shipment => {
                                    const status = shipment.containerStatus;
                                    const RefBL = shipment.referenceNumber != "" ? (shipment.billOfLadingNumber != "" ? shipment.referenceNumber + " - " + shipment.billOfLadingNumber : shipment.referenceNumber) : (shipment.billOfLadingNumber != "" ? shipment.billOfLadingNumber : "");
                                    const ports = {
                                        "PET": "https://www.porteverglades.net/",
                                        "FIT": "https://www.fitpev.com/",
                                        "POMTOC": "http://pomtoc.com/",
                                        "SFCT": "https://www.southfloridacontainer.com/"
                                    };
                                    const portslink = ports[shipment.fromLocationName];
                                    let badgeClass = status === 'PENDING' ? 'badge-bg-green' : (status === 'OPEN' ? 'badge-bg-red' : (status === 'AVAILABLE' ? 'badge-bg-blue' : (status === 'SCHEDULED' ? 'badge-bg-yellow' : (status === 'DISPATCHED' ? 'badge-bg-purple' : (status === 'DELIVERED' ? 'badge-bg-green' : (status === 'COMPLETED' ? 'badge-bg-green' : (status === 'APPROVED' ? 'badge-bg-red' : '')))))));
                                    if (badgeClass.length) badgeClass += ' status-badge';

                                    return (
                                        <tr key={shipment.deliveryContainerId}>
                                            <td>{shipment.deliveryContainerId}</td>
                                            <td>{shipment.orderNumber}</td>
                                            <td>{shipment.bookingNumber}</td>
                                            <td>{shipment.containerNumber}</td>
                                            <td>{shipment.containerSize} {shipment.containerType.split(" - ")[1]}</td>
                                            <td>
                                                <div className={`mx-auto ${badgeClass}`}>{badgeClass.length ? shipment.containerStatus.toLowerCase() : shipment.containerStatus}</div>
                                            </td>
                                            <td>{shipment.etaDate}</td>
                                            <td>{shipment.deliveryType}</td>
                                            <td>{portslink == null ? shipment.fromLocationName : <a href={`${portslink}`} target='_blank' style={{ fontWeight:'bold'}}>{shipment.fromLocationName}</a>}</td>
                                            <td>{shipment.lastFreeDayDate}</td>
                                            <td>{shipment.portStatusName}</td>
                                            <td>{RefBL}</td>
                                            <td>{shipment.returnLastFreeDayDate}</td>
                                            <td>{shipment.toLocationName}</td>
                                            <td>{shipment.traverseType}</td>
                                            <td>
                                                <div className="d-flex flex-row justify-content-center">
                                                    <button onClick={() => this.props.openModal(shipment.deliveryContainerId, shipment.orderNumber)}
                                                        className="btn btn-primary icon-btn" data-toggle="modal" data-target="#invoice-modal">
                                                        <FontAwesomeIcon icon={faFile} size="lg" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                        }
                    </tbody>)}
                </table>
                {
                    this.props.isLoading && (
                        <div className='sweet-loading' style={{ textAlign: 'center' }}>
                            <ClipLoader
                                sizeUnit={"px"}
                                size={250}
                                color={'rgb(54, 215, 183)'}
                                loading={true}
                            />
                        </div>)
                }
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        shipmentsList: state.shipmentData.list,
        isLoading: state.shipmentData.isLoading,
        counts: state.shipmentData.counts
    };
};

const mapDispatchToProps = dispatch => {
    return {
        //openDocumentsModal: this.openModal
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentsTable);


// WEBPACK FOOTER //
// ./src/view/Shipment/ShipmentsTable.js